import { Navigate, Route, Routes } from 'react-router-dom';
import { SiteContentProvider } from '@/__lib/SiteContentProvider';
import { Contact } from '@pages/Contact/Contact';
import { Home } from '@pages/Home/Home';
import { NotFound } from '@pages/NotFound/NotFound';
import { Services } from '@pages/Services/Services';
import { Trainer } from '@pages/Trainer/Trainer';
import { PublicLayout } from './PublicLayout';
import { ScrollToTop } from './ScrollToTop';

export const App = () => (
	<SiteContentProvider>
		<ScrollToTop />
		<Routes>
			<Route element={<PublicLayout />}>
				<Route path="/" element={<Home />} />
				<Route path="/treninky" element={<Services />} />
				<Route path="/treneri" element={<Trainer />} />
				<Route path="/kontakt" element={<Contact />} />
				<Route path="/services" element={<Navigate to="/treninky" replace />} />
				<Route path="/trainer" element={<Navigate to="/treneri" replace />} />
				<Route path="/contact" element={<Navigate to="/kontakt" replace />} />
				<Route path="*" element={<NotFound />} />
			</Route>
		</Routes>
	</SiteContentProvider>
);
